export default [
  {
    "method": "get",
    "path": "/device/api/v1/capability/list",
    "title": "Метод получения возможностей устройства"
  },
  {
    "method": "post",
    "path": "/device/api/v1/code",
    "title": "Метод создания кода доступа"
  },
  {
    "method": "get",
    "path": "/device/api/v1/code/count",
    "title": "Метод получения количества кодов доступа"
  },
  {
    "method": "get",
    "path": "/device/api/v1/code/list",
    "title": "Метод получения списка кодов доступа"
  },
  {
    "method": "delete",
    "path": "/device/api/v1/code/list",
    "title": "Метод удаления списка кодов доступа"
  },
  {
    "method": "post",
    "path": "/device/api/v1/code/list",
    "title": "Метод создания списка кодов доступа"
  },
  {
    "method": "get",
    "path": "/device/api/v1/code/{code}",
    "title": "Метод получения кода доступа"
  },
  {
    "method": "delete",
    "path": "/device/api/v1/code/{code}",
    "title": "Метод удаления одного кода доступа"
  },
  {
    "method": "get",
    "path": "/device/api/v1/concierge/settings",
    "title": "Метод получения настроек Concierge"
  },
  {
    "method": "patch",
    "path": "/device/api/v1/concierge/settings",
    "title": "Метод редактирования настроек Concierge"
  },
  {
    "method": "get",
    "path": "/device/api/v1/dtmf/settings",
    "title": "Метод получения настроек DTMF"
  },
  {
    "method": "patch",
    "path": "/device/api/v1/dtmf/settings",
    "title": "Метод редактирования настроек DTMF"
  },
  {
    "method": "post",
    "path": "/device/api/v1/encryption_profile",
    "title": "Метод создания сущности EncryptionProfile"
  },
  {
    "method": "get",
    "path": "/device/api/v1/encryption_profile/list",
    "title": "Метод получения списка сущностей EncryptionProfile по фильтру"
  },
  {
    "method": "delete",
    "path": "/device/api/v1/encryption_profile/list",
    "title": "Метод удаления списка сущностей EncryptionProfile по фильтру"
  },
  {
    "method": "get",
    "path": "/device/api/v1/encryption_profile/{id}",
    "title": "Метод получения единичной сущности EncryptionProfile по ключу"
  },
  {
    "method": "delete",
    "path": "/device/api/v1/encryption_profile/{id}",
    "title": "Метод удаления единичной сущности EncryptionProfile по ключу"
  },
  {
    "method": "get",
    "path": "/device/api/v1/facerec",
    "title": "Метод получения настроек Face Recognition"
  },
  {
    "method": "patch",
    "path": "/device/api/v1/facerec",
    "title": "Метод редактирования настроек Face Recognition"
  },
  {
    "method": "get",
    "path": "/device/api/v1/ftp",
    "title": "Метод получения настроек FTP"
  },
  {
    "method": "patch",
    "path": "/device/api/v1/ftp",
    "title": "Метод редактирования настроек FTP"
  },
  {
    "method": "post",
    "path": "/device/api/v1/ftp/backup",
    "title": "Создать бэкап и положить на FTP папку"
  },
  {
    "method": "post",
    "path": "/device/api/v1/ftp/backup/apply",
    "title": "Скачать бэкап из FTP папки и применить"
  },
  {
    "method": "get",
    "path": "/device/api/v1/gate/mode",
    "title": "Метод получения Gate режима"
  },
  {
    "method": "post",
    "path": "/device/api/v1/gate/mode",
    "title": "Метод редактирования Gate режима"
  },
  {
    "method": "get",
    "path": "/device/api/v1/ntp",
    "title": "Метод получения настроек NTP"
  },
  {
    "method": "patch",
    "path": "/device/api/v1/ntp",
    "title": "Метод редактирования настроек NTP"
  },
  {
    "method": "patch",
    "path": "/device/api/v1/reader/{data.id}",
    "title": "Метод редактирования считывателя"
  },
  {
    "method": "get",
    "path": "/device/api/v1/reader/{id}",
    "title": "Метод получения считывателя"
  },
  {
    "method": "get",
    "path": "/device/api/v1/relay/dtmf/list",
    "title": "Метод получения настроек DTMF реле"
  },
  {
    "method": "get",
    "path": "/device/api/v1/relay/open/list",
    "title": "Метод получения настроек открытия реле"
  },
  {
    "method": "get",
    "path": "/device/api/v1/relay/status/list",
    "title": "Метод получения статусов реле устройства"
  },
  {
    "method": "patch",
    "path": "/device/api/v1/relay/{data.relayIndex}/props/dtmf",
    "title": "Метод редактирования настроек DTMF реле"
  },
  {
    "method": "patch",
    "path": "/device/api/v1/relay/{data.relayIndex}/props/open",
    "title": "Метод редактирования настроек открытия реле"
  },
  {
    "method": "post",
    "path": "/device/api/v1/relay/{relayIndex}/close",
    "title": "Метод закрытия реле.\nЗакрытие реле принудительно без учета времени открытия.\nОтмена режима постоянного открытия"
  },
  {
    "method": "post",
    "path": "/device/api/v1/relay/{relayIndex}/open",
    "title": "Метод открытия реле"
  },
  {
    "method": "post",
    "path": "/device/api/v1/relay/{relayIndex}/open_permanently",
    "title": "Метод открытия реле без дальнейшего закрытия"
  },
  {
    "method": "post",
    "path": "/device/api/v1/rfid",
    "title": "Метод редактирования сущности Rfid"
  },
  {
    "method": "get",
    "path": "/device/api/v1/rfid/count",
    "title": "Метод получения количества сущностей Rfid по фильтру"
  },
  {
    "method": "get",
    "path": "/device/api/v1/rfid/list",
    "title": "Метод получения списка сущностей Rfid по фильтру"
  },
  {
    "method": "delete",
    "path": "/device/api/v1/rfid/list",
    "title": "Метод удаления списка сущностей Rfid по фильтру"
  },
  {
    "method": "post",
    "path": "/device/api/v1/rfid/list",
    "title": "Метод редактирования списка сущностей Rfid"
  },
  {
    "method": "get",
    "path": "/device/api/v1/rfid/{id}",
    "title": "Метод получения единичной сущности Rfid по ключу"
  },
  {
    "method": "delete",
    "path": "/device/api/v1/rfid/{id}",
    "title": "Метод удаления единичной сущности Rfid по ключу"
  },
  {
    "method": "post",
    "path": "/device/api/v1/room",
    "title": "Метод сохранения настроек квартиры.\nПоддерживает создание и обновление"
  },
  {
    "method": "get",
    "path": "/device/api/v1/room/count",
    "title": "Метод получения количества квартир"
  },
  {
    "method": "get",
    "path": "/device/api/v1/room/list",
    "title": "Метод получения списка настроек квартир"
  },
  {
    "method": "delete",
    "path": "/device/api/v1/room/list",
    "title": "Метод удаления списка настроек квартиры.\nПри отсутствующем или пустом фильтре удаляются все квартиры"
  },
  {
    "method": "post",
    "path": "/device/api/v1/room/list",
    "title": "Метод сохранения списка настроек квартиры"
  },
  {
    "method": "get",
    "path": "/device/api/v1/room/{roomNumber}",
    "title": "Метод получения настроек квартиры"
  },
  {
    "method": "delete",
    "path": "/device/api/v1/room/{roomNumber}",
    "title": "Метод удаления настроек квартиры"
  },
  {
    "method": "get",
    "path": "/device/api/v1/rtsp",
    "title": "Метод получения настроек RTSP"
  },
  {
    "method": "post",
    "path": "/device/api/v1/rtsp",
    "title": "Метод редактирования настроек RTSP"
  },
  {
    "method": "get",
    "path": "/device/api/v1/sac",
    "title": "Метод получения настроек Smart Auto Collect"
  },
  {
    "method": "patch",
    "path": "/device/api/v1/sac",
    "title": "Метод редактирования настроек Smart Auto Collect"
  },
  {
    "method": "post",
    "path": "/device/api/v1/safe_city/emergency/start",
    "title": "Старт оповещения.\nГде Tick - один цикл оповещения на одном или двух направлениях (трубка, динамик или трубка и динамик).\nplaybacks_per_tick - Количество воспроизведений файла в каждом цикле оповещения на одном направлении (трубка или динамик).\ntick_count - Количество воспроизведений циклов оповещения.\nДлительность оповещения = tick_count * (Х * playbacks_per_tick (трубка) + Х * playbacks_per_tick (динамик)).\ntotal_duration - Максимальная общая длительность оповещения. По истечении total_duration секунд оповещение прекращается независимо от количества циклов"
  },
  {
    "method": "get",
    "path": "/device/api/v1/safe_city/emergency/status",
    "title": "Получение статуса оповещения"
  },
  {
    "method": "post",
    "path": "/device/api/v1/safe_city/emergency/stop",
    "title": "Прекращение оповещения"
  },
  {
    "method": "post",
    "path": "/device/api/v1/safe_city/emergency_file",
    "title": "Метод загрузки файла на устройство.\nSyslog: EVENT:000: Upload Emergency File: File size nnn byte: File Duration nnn sec"
  },
  {
    "method": "get",
    "path": "/device/api/v1/safe_city/emergency_file/list",
    "title": "Метод получения списка файлов оповещения.\nВ ответе только массив file_name, необязательный параметр content не присутствует"
  },
  {
    "method": "delete",
    "path": "/device/api/v1/safe_city/emergency_file/{fileName}",
    "title": "Метод удаления единичной сущности SafeCityEmergencyFile по ключу"
  },
  {
    "method": "get",
    "path": "/device/api/v1/safe_city/osd",
    "title": "Метод получения настроек OSD"
  },
  {
    "method": "patch",
    "path": "/device/api/v1/safe_city/osd",
    "title": "Метод редактирования настроек OSD"
  },
  {
    "method": "get",
    "path": "/device/api/v1/sip/account/list",
    "title": "Метод получения списка Sip-аккаунтов"
  },
  {
    "method": "get",
    "path": "/device/api/v1/sip/account/status/list",
    "title": "Метод получения статусов регистрации Sip-аккаунтов"
  },
  {
    "method": "patch",
    "path": "/device/api/v1/sip/account/{data.accountId}",
    "title": "Метод редактирования Sip-аккаунта"
  },
  {
    "method": "get",
    "path": "/device/api/v1/sip/timeout/settings",
    "title": "Метод получения настроек максимального времени общения и дозвона"
  },
  {
    "method": "patch",
    "path": "/device/api/v1/sip/timeout/settings",
    "title": "Метод редактирования настроек максимального времени общения и дозвона"
  },
  {
    "method": "get",
    "path": "/device/api/v1/sos",
    "title": "Метод получения настроек SOS"
  },
  {
    "method": "patch",
    "path": "/device/api/v1/sos",
    "title": "Метод редактирования настроек SOS"
  },
  {
    "method": "get",
    "path": "/device/api/v1/syslog/settings",
    "title": "Метод получения настроек Syslog-сервера"
  },
  {
    "method": "patch",
    "path": "/device/api/v1/syslog/settings",
    "title": "Метод редактирования настроек Syslog-сервера"
  },
  {
    "method": "get",
    "path": "/device/api/v1/system/info",
    "title": "Метод получения общей информации об устройстве"
  },
  {
    "method": "post",
    "path": "/device/api/v1/system/reboot",
    "title": "Метод удаленной перезагрузки"
  },
  {
    "method": "get",
    "path": "/device/api/v1/ticker",
    "title": "Метод получения настроек Ticker"
  },
  {
    "method": "patch",
    "path": "/device/api/v1/ticker",
    "title": "Метод редактирования настроек Ticker"
  },
  {
    "method": "post",
    "path": "/device/api/v1/update/apply",
    "title": "Запустить обновление домофона"
  },
  {
    "method": "post",
    "path": "/device/api/v1/update/download",
    "title": "Скачать прошивку для обновления"
  },
  {
    "method": "post",
    "path": "/device/api/v1/user",
    "title": "Метод создания/редактирования сущности User"
  },
  {
    "method": "get",
    "path": "/device/api/v1/user/list",
    "title": "Метод получения списка сущностей User по фильтру"
  },
  {
    "method": "delete",
    "path": "/device/api/v1/user/{username}",
    "title": "Метод удаления единичной сущности User по ключу"
  },
  {
    "method": "post",
    "path": "/device/api/v1/user/{username}/name/replace",
    "title": "Метод замены имени пользователя"
  },
  {
    "method": "post",
    "path": "/device/api/v1/user/{username}/password/replace",
    "title": "Метод замены пароля пользователя"
  },
  {
    "method": "post",
    "path": "/device/api/v1/user/{username}/permission/replace",
    "title": "Метод замены пароля пользователя.\nБудут изменены только явно переданные в data.permission разрешения"
  },
  {
    "method": "get",
    "path": "/device/api/v1/video_channel/list",
    "title": "Метод получения списка сущностей VideoChannel по фильтру"
  },
  {
    "method": "patch",
    "path": "/device/api/v1/video_channel/{data.chanelNumber}",
    "title": "Метод редактирования единичной сущности VideoChannel по ключу"
  }
];
